import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bundle from './Bundle';
import KioskBundle from './KioskBundle';
import { connect } from 'react-redux';
import { isKioskMode, getFeeDisplayOption } from 'checkout/selectors/ui';
import { getMainEvent, isSeries } from '../../../selectors/event';
import Translation from "../../../../shared/Translation";

class Bundles extends Component {
    render() {
        if(Object.keys(this.props.bundles).length === 0) {
            return null;
        }

        return (<ul className="tickets__list">
            <li className="ticket__header">
                <div className="ticket-header__name" role='heading' aria-level={this.props.isSeries ? 4 : 3}>{this.props.header !== undefined ? this.props.header : <Translation>{'checkout__bundles'}</Translation>}</div>
                <div className="ticket-header__price"></div>
                <div className="ticket-header__quantity"></div>
            </li>
            {this.renderBundles()}
        </ul>);
    }

    renderBundles = () => {
        if(this.props.bundles) {
            return Object.values(this.props.bundles)
                .sort((a, b) => a.position - b.position)
                .map((bundle) => {
                    if (this.props.isKioskMode){
                        return(
                            <KioskBundle
                                key={bundle.id}
                                bundle={bundle}
                                onIncrement={this.props.onIncrement}
                                onDecrement={this.props.onDecrement}
                                onQuantityChange={this.props.onQuantityChange(bundle.id)}
                                quantities={this.props.quantityArrays[bundle.id]}
                                bundleQuantity={this.props.bundleQuantities[bundle.id]}
                                initialQuantities={this.props.initialQuantities[bundle.id]}
                                isPackage={this.props.isPackage}
                                reducerKey={this.props.reducerKey}
                            />
                        )
                    }
                    return <Bundle
                        key={bundle.id}
                        bundle={bundle}
                        onIncrement={this.props.onIncrement}
                        onDecrement={this.props.onDecrement}
                        onQuantityChange={this.props.onQuantityChange(bundle.id)}
                        quantities={this.props.quantityArrays[bundle.id]}
                        bundleQuantity={this.props.bundleQuantities[bundle.id]}
                        initialQuantities={this.props.initialQuantities[bundle.id]}
                        isPackage={this.props.isPackage}
                        feeDisplayOption={this.props.feeDisplayOption}
                        reducerKey={this.props.reducerKey}
                    />
                });
        }
    }


}

const mapStateToProps = state => {
    return {
        header: state.ui.checkoutConfig.bundlesHeader,
        isPackage: !!getMainEvent(state)?.event?.isPackage,
        isKioskMode: isKioskMode(state),
        feeDisplayOption: getFeeDisplayOption(state),
        isSeries: isSeries(state),
    }
};

Bundles.propTypes = {
    bundles: PropTypes.object,
    quantityArrays: PropTypes.object,
    bundleQuantities: PropTypes.object,
    onQuantityChange: PropTypes.func.isRequired,
    initialQuantities: PropTypes.object,
    onIncrement: PropTypes.func.isRequired,
    onDecrement: PropTypes.func.isRequired,
}

export default connect(mapStateToProps)(Bundles)
